export default __webpack_public_path__ + "static/media/image-from-rawpixel-id-2858870.73daa3a2.png";